/**
 * Central configuration for the frontend, loaded from Vite environment variables.
 * All VITE_* vars are baked into the build at compile time.
 */
export const config = {
  entraTenantId: import.meta.env.VITE_ENTRA_TENANT_ID,
  entraClientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  apiScope: import.meta.env.VITE_API_SCOPE,
  // v1.2.0: write scope for schedule changes. Optional — derived from the
  // read scope's resource (api://<client-id>/Overrides.Write) when not set.
  apiWriteScope:
    import.meta.env.VITE_API_WRITE_SCOPE ||
    String(import.meta.env.VITE_API_SCOPE ?? '').replace(/\/[^/]+$/, '/Overrides.Write'),
  refreshIntervalMs: 60_000,
  // While a window is pending or cancelling, the schedule page polls faster.
  scheduleFastRefreshMs: 15_000,
} as const

// Sanity check on module load — fail fast if any required config is missing
const required = ['entraTenantId', 'entraClientId', 'apiBaseUrl', 'apiScope'] as const
for (const key of required) {
  if (!config[key]) {
    throw new Error(
      `Missing required config: VITE_${key.replace(/([A-Z])/g, '_$1').toUpperCase()}. ` +
      `Check your .env.local (dev) or Static Web App Application Settings (prod).`,
    )
  }
}
